import { HttpContextToken } from '@angular/common/http';

/**
 * Usar para saltear el agregado de Authorization en una request puntual
 */
export const SKIP_AUTH = new HttpContextToken<boolean>(() => false);
